export const getPublicPageToken = (key: string) => {
  try {
    return localStorage.getItem(key);
  } catch (_: unknown) {
    return null;
  }
};
